import PropTypes from 'prop-types';
import React from 'react';
import { Trans } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Button } from '@shared/ui/components/Button';
import { Icon } from '@shared/ui/components/Icon';
import { Portlet } from '@shared/ui/components/Portlet';

import { ajaxErrorHandler, defaultSuccess } from '../../../../libs/utils';
import axiosInstance from '../../../../services/api';
import { generateCateringInvoice } from '../../../../services/api/registrations';
import CateringCostOverviewButton from '../../../shared/catering/CateringCostOverviewButton';
import CateringTable from '../../../shared/catering/CateringTable';

const fileDownload = require('js-file-download');

class RegistrationCatering extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this._generateInvoice = this._generateInvoice.bind(this);
    this._downloadInvoice = this._downloadInvoice.bind(this);
  }

  static propTypes = {
    registration: PropTypes.object,
    refreshRegistration: PropTypes.func,
  };

  _generateInvoice() {
    generateCateringInvoice(this.props.registration.id)
      .then((response) => {
        defaultSuccess('Invoice is being generated please check back in a couple of minutes.');
        this.props.refreshRegistration();
      })
      .catch(ajaxErrorHandler);
  }

  _downloadInvoice() {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const registrationId = this.props.registration.id;
    axiosInstance({
      method: 'get',
      url: `${baseUrl}registrations/${registrationId}/download-catering-invoice`,
      responseType: 'blob',
    }).then((response) => {
      fileDownload(
        response.data,
        `${this.props.registration.event.name} - ${this.props.registration.company.name} - Catering Invoice.pdf`
      );
    });
  }

  render() {
    const { registration } = this.props;
    return (
      <Portlet
        title="Catering Overview"
        icon="catering"
        actions={
          <>
            <CateringCostOverviewButton registration={registration} />

            <Button onClick={this._generateInvoice} variant="outline">
              <Icon icon="plus" />
              <Trans>Generate Invoice</Trans>
            </Button>

            {registration.cateringInvoiceUpdatedAt && (
              <Button onClick={this._downloadInvoice} variant="outline">
                <Icon icon="download" />
                <Trans>Download Invoice</Trans>
              </Button>
            )}
          </>
        }
      >
        <div className="alert alert-info">
          <Trans>CateringRequestMsg</Trans>
        </div>
        <CateringTable registration={registration} admin />
      </Portlet>
    );
  }
}

export default RegistrationCatering;
